<nav aria-label="Navigation principale">
  <div class="nav__container-desktop">
    <div>
      <a routerLink="/"> <img src="/icons/navbar/navbar-logo.svg" alt="CESCOG-LOGO" /> </a>
    </div>
    <ul class="nav__links">
      <li><a routerLink="/tarifs" class="tarifs">Tarifs</a></li>
      <li>
        <a routerLink="/rendez-vous" class="btn btn-primary">Prendre rendez-vous</a>
      </li>

      <li>
        <a routerLink="/connexion" class="btn btn-primary-outline">Connexion</a>
      </li>
    </ul>
  </div>

  <div class="nav__container-tablet">
    <div>
      <a routerLink="/"> <img src="/icons/navbar/navbar-logo.svg" alt="CESCOG-LOGO" /> </a>
    </div>
    <ul class="nav__links">
      <li>
        <a
          class="btn btn-primary"
          (click)="toggleMenu()"
          [attr.aria-expanded]="menuOpen"
          aria-controls="mobile-menu"
          aria-label="Menu"
          >Menu</a
        >
      </li>
    </ul>
  </div>

  <div class="nav__menu" [class.nav__menu--open]="menuOpen">
    <ul class="nav__links">
      <li>
        <a routerLink="/tarifs">Tarifs</a>
      </li>
      <li>
        <a routerLink="/rendez-vous">Prendre rendez-vous</a>
      </li>

      <li>
        <a routerLink="/connexion">Connexion</a>
      </li>
    </ul>
  </div>
</nav>
